(function() {
  'use strict';

  function initFormValidation(formSelector) {
    var form = document.querySelector(formSelector);
    if (!form) return;

    // Disable native browser validation UI
    form.setAttribute('novalidate', 'novalidate');

    // Get all required fields
    var requiredFields = form.querySelectorAll('[required]');

    // Add validation on input/change
    requiredFields.forEach(function(field) {
      var eventType = field.tagName === 'SELECT' ? 'change' : 'input';

      field.addEventListener(eventType, function() {
        validateField(field);
      });

      field.addEventListener('blur', function() {
        validateField(field);
      });
    });

    // Validate on submit - use capture phase to run first
    form.addEventListener('submit', function(e) {
      var isValid = validateForm(form);

      if (!isValid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
    }, true);
  }

  function validateForm(form) {
    var requiredFields = form.querySelectorAll('[required]');
    var isValid = true;
    var firstInvalidField = null;

    requiredFields.forEach(function(field) {
      if (!validateField(field)) {
        isValid = false;
        if (!firstInvalidField) {
          firstInvalidField = field;
        }
      }
    });

    if (!isValid && firstInvalidField) {
      firstInvalidField.focus();
    }

    return isValid;
  }

  function validateField(field) {
    var isValid = true;
    var value = field.value.trim();

    // Check if empty
    if (!value) {
      isValid = false;
    }

    // Check email format
    if (field.type === 'email' && value) {
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isValid = emailRegex.test(value);
    }

    // Update UI
    var errorElement = document.getElementById(field.id + '-error');

    if (!isValid) {
      field.classList.add('field__input--error');
      if (errorElement) {
        errorElement.style.display = 'block';
      }
    } else {
      field.classList.remove('field__input--error');
      if (errorElement) {
        errorElement.style.display = 'none';
      }
    }

    return isValid;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initFormValidation('#ContactForm');
    });
  } else {
    initFormValidation('#ContactForm');
  }
})();
